import { Container, Row, Col } from "reactstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./CourseHeroSection.css";
import CourseEnquiryButton from "../../CAD_Home/CourseEnquiryButton";

function CourseHeroSection({
    badge,
    title,
    titleHighlight,
    description,
    logo,
    logoAlt = "Course Logo",
    features = [],
    buttonText = "Start with Free Classes",
}) {

    return (
        <section className="course-hero-section">

            <Container>

                <div className="course-hero-card">

                    {/* =========================================
                        HERO HEADER
                    ========================================= */}

                    <Row className="align-items-center">

                        {/* Logo */}

                        <Col
                            lg="4"
                            md="5"
                            className="text-center"
                        >

                            <div className="course-logo-wrapper">

                                <img
                                    src={logo}
                                    alt={logoAlt}
                                    className="course-logo"
                                />

                            </div>

                        </Col>


                        {/* Content */}

                        <Col
                            lg="8"
                            md="7"
                        >

                            <div className="course-hero-content">

                                <span className="course-badge">
                                    {badge}
                                </span>


                                <h1>
                                    {title}

                                    {titleHighlight && (
                                        <span>
                                            {" "}
                                            {titleHighlight}
                                        </span>
                                    )}
                                </h1>


                                <p className="course-description">
                                    {description}
                                </p>

                            </div>

                        </Col>

                    </Row>


                    {/* =========================================
                        FEATURES
                    ========================================= */}

                    {features.length > 0 && (

                        <div className="course-features">

                            <h4>
                                Why Learn {title} With Us?
                            </h4>


                            <Row>

                                {features.map((feature, index) => (

                                    <Col
                                        lg="6"
                                        md="6"
                                        key={index}
                                    >

                                        <div className="course-feature-item">

                                            <CheckCircleIcon className="course-check-icon" />

                                            <span>
                                                {feature}
                                            </span>

                                        </div>

                                    </Col>

                                ))}

                            </Row>

                        </div>

                    )}


                    {/* =========================================
                        CTA
                    ========================================= */}

                    <div className="course-cta">

                        <CourseEnquiryButton
                            buttonText={buttonText}
                        />

                        <p>
                            No commitment required
                            <span> • </span>
                            Learn before you decide
                        </p>

                    </div>

                </div>

            </Container>

        </section>
    );
}

export default CourseHeroSection;